import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../utils/api';

// Query keys
const EVENT_REQUESTS_QUERY_KEY = 'event-requests';

// Custom hook for fetching event requests
export const useEventRequests = (page = 1, limit = 10) => {
  return useQuery({
    queryKey: [EVENT_REQUESTS_QUERY_KEY, page, limit],
    queryFn: async () => {
      const response = await apiClient.get('event-requests', {
        page,
        limit
      });
      return {
        data: response.data || [],
        total: response.total || 0,
        page: response.page || 1,
        limit: response.limit || 10,
        hasNext: response.has_next || false,
        hasPrev: response.has_prev || false
      };
    },
    keepPreviousData: true,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
};

// Custom hook for getting a single event request
export const useEventRequest = (id) => {
  return useQuery({
    queryKey: [EVENT_REQUESTS_QUERY_KEY, id],
    queryFn: () => apiClient.get(`event-requests/${id}`),
    enabled: !!id,
  });
};

// Custom hook for updating event request status
export const useUpdateEventRequestStatus = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, status }) => {
      return apiClient.put(`event-requests/${id}/status`, { status });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [EVENT_REQUESTS_QUERY_KEY] });
    },
  });
};

// Custom hook for deleting an event request
export const useDeleteEventRequest = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (id) => apiClient.delete(`event-requests/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [EVENT_REQUESTS_QUERY_KEY] });
    },
  });
};
